var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.7428C24.2843 30.7428 31 24.0847 31 15.8714C31 7.65816 24.2843 1 16 1C7.71573 1 1 7.65816 1 15.8714C1 24.0847 7.71573 30.7428 16 30.7428Z",
    fill: "white",
    stroke: "#13C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4497 30.6533C13.3249 30.4936 13.3249 29.0706 13.4497 26.3846C12.113 26.4304 11.2685 26.3385 10.9162 26.1088C10.3876 25.7642 9.85849 24.7016 9.38894 23.9527C8.91945 23.2038 7.87745 23.0854 7.45665 22.918C7.03585 22.7506 6.93022 22.0682 8.61616 22.5843C10.302 23.1004 10.3843 24.5059 10.9162 24.8345C11.448 25.1631 12.7195 25.0194 13.2958 24.7561C13.8722 24.4928 13.8298 23.5126 13.9326 23.1243C14.0625 22.7618 13.6046 22.6814 13.5945 22.6784C13.0318 22.6784 10.0759 22.0411 9.26404 19.2033C8.4521 16.3655 9.49797 14.5106 10.0559 13.7132C10.4279 13.1816 10.395 12.0487 9.9572 10.3144C11.5466 10.113 12.7732 10.609 13.6369 11.8024C13.6377 11.8092 14.7692 11.1353 16.5575 11.1353C18.3456 11.1353 18.98 11.6843 19.4696 11.8024C19.9593 11.9205 20.3508 9.71337 23.3746 10.3144C22.7433 11.5445 22.2146 13.0817 22.6181 13.7132C23.0216 14.3448 24.6053 16.3531 23.6325 19.2033C22.984 21.1034 21.7091 22.2618 19.8078 22.6784C19.5898 22.7474 19.4808 22.8587 19.4808 23.0122C19.4808 23.2425 19.7756 23.2677 20.2002 24.3466C20.4833 25.0659 20.5037 27.1202 20.2615 30.5096C19.648 30.6645 19.1707 30.7684 18.8296 30.8216C18.2248 30.9158 17.5682 30.9686 16.923 30.989C16.2778 31.0094 16.0538 31.0071 15.1618 30.9248C14.5672 30.8699 13.9965 30.7794 13.4497 30.6533Z",
    fill: "#13C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.9ddf5eb0fd97c9b2cbc85b749730dd7a.svg";
export { ForwardRef as ReactComponent };